import React, { Component } from 'react'
import { Form, Table } from 'react-bootstrap';

export class searchEmployee extends Component {
    constructor(props) {
        super(props);
        this.state = {
            busqueda: "",
            nombre:""
        }
    }

    localevent = (currentData) => {
        const { event } = this.props;
        this.setState({
            busqueda: "",
            nombre: currentData.NOMBRE_1
        })
        event(currentData);
    }
    render() {
        const { data } = this.props;
        const { client } = this.props;
        const { busqueda } = this.state;
        const { nombre } = this.state;
        //console.log(nombre)
        const localevent = this.localevent;
        return (
            <div>
                <div>
                    {nombre.length > 0 && <Form.Control autoComplete="off" className="mb-2 mr-sm-2" id="Nombre" onKeyUp={(e) => this.setState({ busqueda: e.target.value, nombre: "" })} defaultValue={nombre}/>}
                    {nombre.length === 0 && <Form.Control autoComplete="off" className="mb-2 mr-sm-2" id="busquedaItem" placeholder="Nit o Nombre" onChange={(e) => this.setState({ busqueda: e.target.value })} defaultValue={client} />}
                </div>
                {(busqueda.length > 1 && data.length > 0) &&
                    <div className="scrollTable">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Nit</th>
                                    <th>Nombre</th>
                                </tr>
                            </thead>
                            <tbody>

                                {data.map((currentData, index) => {
                                    if (currentData.DOCUMENTO_EMPLEADO.toString().toLowerCase().search(busqueda.toLowerCase()) > -1
                                        || currentData.NOMBRE_COMPLETO.toLowerCase().search(busqueda.toLowerCase()) > -1) {
                                        return <tr key={index + "d0"} onClick={() => localevent(currentData)}>
                                            <td key={index + "d1"}>{currentData.DOCUMENTO_EMPLEADO}</td>
                                            <td key={index + "d2"}>{currentData.NOMBRE_COMPLETO}</td>
                                        </tr>
                                    } else {
                                        return null;
                                    }
                                })}
                            </tbody>
                        </Table>

                    </div>
                }
            </div>
        )
    }
}

export default searchEmployee
